import { request, type RequestOptions } from "../client";
export const hubKeys = {
  all: ["hub"] as const,
  tasks: ["hub", "tasks"] as const,
  projects: ["hub", "projects"] as const,
  people: ["hub", "people"] as const,
  me: ["hub", "me"] as const,
  calendar: ["hub", "calendar"] as const,
  settings: ["hub", "settings"] as const,
};
/** 同源认证、401 刷新和中文错误均复用知识库客户端。仅解包契约的 data。 */
export async function hubRequest<T>(
  path: string,
  options: RequestInit = {},
  query?: RequestOptions["query"],
): Promise<T> {
  const body =
    typeof options.body === "string"
      ? (JSON.parse(options.body) as unknown)
      : options.body;
  const result = await request<{ data: T }>(
    path.startsWith("/hub/") ? path : `/hub/api${path}`,
    {
      method: options.method as RequestOptions["method"],
      body: body ?? undefined,
      signal: options.signal ?? undefined,
      query,
      headers: options.headers
        ? Object.fromEntries(new Headers(options.headers))
        : undefined,
    },
  );
  return result.data;
}
export const hubBody = (body: unknown, method = "POST"): RequestInit => ({
  method,
  body: JSON.stringify(body),
});

/** 私有图片也复用同源身份、空间、401刷新和中文错误。 */
export async function hubBlob(path: string): Promise<Blob> {
  const response = await request<Response>(path.startsWith('/hub/') ? path : `/hub/api${path}`, { raw: true })
  return response.blob()
}
